<template>
<div class="chapter">
<div class="inner_page">
<p class="textcenter"><a id="ch00_fm06"></a><a id="page_vii"></a>For Anne,<br/>best friend and best blonde<a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm06.vue?61a047b0